import { useTranslation } from "react-i18next";
import CardBase from "../../../components/CardBase";
import { useContext } from "react";
import { GlobalContext } from "../../../../../common/Context";
import { Box, Typography } from "@mui/material";
import LoadingWheel from "../../../../../common/LoadingWheel";
import { green, purple, white } from "../../../../../../theme/colours";
import { TotalIcon } from "../../../../../common/Icons";
import { DASHBOARD_SRC } from "../../../../../../constants/ids";

const SRCCard = ({ userCompTeams, banner }) => {
  const { t } = useTranslation("Dashboard");
  const {
    desktopView,
    largeView,
    tabletView,
    mobileView,
    setOptionState,
    competitionList,
  } = useContext(GlobalContext);

  const SRCBoxStyle = {
    width: largeView ? "32.5%" : !desktopView ? "100%" : "36%",
    mt: !desktopView && "2rem",
    height: "100%",
  };
  const SRCAreaStyle = {
    width: "100%",
    height: "100%",
    padding: "1rem",
    display: "flex",
    flexDirection: tabletView ? "row" : "column",
    justifyContent: "space-between",
  };
  const sectionStyle = {
    display: "flex",
    flexDirection: "column",
    width: tabletView ? "47%" : "100%",
  };
  const textStyle = {
    fontSize: "0.875rem",
    fontWeight: 700,
  };
  const teamProgTextStyle = {
    ...textStyle,
    mb: "0.5rem",
  };
  const cardContainerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
  };
  const teamLeaderboardTileStyle = {
    width: "100%",
    height: "45%",
    background: white,
    mb: mobileView && "0.5rem",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 1.25rem",
  };
  const scoreBoxStyle = {
    display: "flex",
  };
  const scoreIconStyle = {
    width: "25px",
    fill: green[2],
  };
  const srcMiniBannerStyle = {
    cursor: "pointer",
    width: "100%",
    borderRadius: "10px",
  };
  const scoreTextStyle = {
    ...textStyle,
    color: green[2],
    ml: "0.5rem",
  };
  const errorBoxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flexDirection: "column",
  };
  const errorSubTitleStyle = {
    opacity: "50%",
    mt: "0.5rem",
    textAlign: "center",
    width: "350px",
    lineHeight: "1.5",
  };

  const changeNav = (type) => {
    setOptionState({ nav: type, page: "main" });
  };

  return (
    <CardBase
      title={t("SRC")}
      redirect={competitionList?.parents?.length ? "safeRoads" : null}
      headerColor={purple[3]}
      boxStyle={SRCBoxStyle}
      areaStyle={SRCAreaStyle}>
      {userCompTeams ? (
        userCompTeams.length ? (
          <>
            <Box sx={{ ...sectionStyle, mb: mobileView && "1rem" }}>
              <Typography variant="h3" sx={teamProgTextStyle}>
                {t("teamProgress")}
              </Typography>
              <Box sx={cardContainerStyle} id={DASHBOARD_SRC}>
                {userCompTeams ? (
                  userCompTeams.slice(0, 2).map((competition) => (
                    <Box sx={teamLeaderboardTileStyle} key={competition.id}>
                      <Typography sx={textStyle}>
                        {competition.teamName}
                      </Typography>
                      <Box sx={scoreBoxStyle}>
                        <TotalIcon style={scoreIconStyle} />
                        <Typography sx={scoreTextStyle}>
                          {competition.scores.total}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <LoadingWheel width={3} />
                )}
              </Box>
            </Box>
            <Box sx={sectionStyle}>
              <Typography variant="h3" sx={teamProgTextStyle}>
                {t("featChallenge")}
              </Typography>
              {banner.data && (
                <Box
                  component="img"
                  src={tabletView ? banner.data.tablet : banner.data.desktop}
                  alt={t("teamsIcon")}
                  onClick={() =>
                    competitionList?.parents?.length && changeNav("safeRoads")
                  }
                  sx={srcMiniBannerStyle}
                />
              )}
            </Box>
          </>
        ) : (
          <Box sx={errorBoxStyle}>
            <Typography variant="h4">{t("noSafeRoadsT")}</Typography>
            <Typography sx={errorSubTitleStyle}>{t("noSafeRoadsD")}</Typography>
          </Box>
        )
      ) : (
        <LoadingWheel width={3} />
      )}
    </CardBase>
  );
};

export default SRCCard;
